<template>
  <div>
    <v-btn
      class="mt-6 mx-auto d-block cloudAuthBtn"
      :disabled="loading || cloudLoading"
      @click="googleAuth"
      type="submit"
    >
      <the-icon class="mr-2" icon="google" />
      Continue with Google
    </v-btn>

    <v-btn
      class="mt-2 mx-auto d-block cloudAuthBtn"
      :disabled="loading"
      @click="githubAuth"
      type="submit"
    >
      <v-icon dark left> mdi-github </v-icon>
      Continue with Github
    </v-btn>

    <v-btn
      class="mt-2 mx-auto d-block cloudAuthBtn"
      :disabled="loading"
      @click="bitbucketAuth"
      type="submit"
    >
      <v-icon dark class="ml-3" left color="blue">mdi-bitbucket</v-icon>
      Continue with Bitbucket
    </v-btn>
  </div>
</template>

<script>
import { GITHUB_CLIENT_ID, BITBUCKET_KEY } from '@/env'

function isGoogleAuthCancelled(error) {
  const message = error?.error || error?.details || ''
  return (
    message === 'popup_closed_by_user' ||
    message === 'access_denied' ||
    error?.type === 'popup_closed'
  )
}

function parseGoogleAuthErrors(error) {
  const body = error?.body
  if (body?.errors) {
    if (Array.isArray(body.errors)) return body.errors
    if (typeof body.errors === 'object') {
      return Object.entries(body.errors).flatMap(([key, messages]) =>
        messages.map((message) => `${key} ${message}`)
      )
    }
  }
  if (body?.error && Array.isArray(body.error)) return body.error
  return ['Unable to authenticate with Google']
}

export default {
  name: 'CloudAuth',
  props: {
    loading: Boolean,
  },
  data() {
    return {
      cloudLoading: false,
    }
  },
  methods: {
    setCloudLoading(value) {
      this.cloudLoading = value
      this.$emit('auth-loading', value)
    },

    async googleAuth() {
      this.$emit('auth-error', [])
      this.setCloudLoading(true)
      try {
        let authCode
        try {
          authCode = await this.$gAuth.getAuthCode()
        } catch (error) {
          if (isGoogleAuthCancelled(error)) return
          throw error
        }
        const res = await this.$store.dispatch('user/googleAuth', authCode)
        if (!res.body.token) {
          const errors = res.body.errors || [
            'Unable to authenticate with Google',
          ]
          this.$emit('auth-error', errors)
          return
        }
        await this.$store.dispatch('application/load')
        if (this.$route.query.redirect) {
          this.$router.push({ path: this.$route.query.redirect })
        } else {
          this.$router.push({ name: 'dashboard' })
        }
      } catch (error) {
        this.$emit('auth-error', parseGoogleAuthErrors(error))
      } finally {
        this.setCloudLoading(false)
      }
    },

    bitbucketAuth() {
      let redirect_host = window.location.host.split('.')[0]
      let redirect_uri =
        'https://api.getforge.com/oauth/bitbucket/' +
        redirect_host +
        '?logAuth=true'
      let oauthUrl =
        'https://bitbucket.org/site/oauth2/authorize?client_id=' +
        BITBUCKET_KEY +
        '&response_type=code&redirect_uri=' +
        redirect_uri
      window.location = oauthUrl
    },
    githubAuth() {
      let redirect_host = window.location.host.split('.')[0]
      let redirect_uri =
        'https://api.getforge.com/oauth/github/' + redirect_host + '?logAuth=true'
      let oauthUrl =
        'http://github.com/login/oauth/authorize?client_id=' +
        GITHUB_CLIENT_ID +
        '&scope=repo,user&redirect_uri=' +
        redirect_uri
      window.location = oauthUrl
    },
  },
}
</script>

<style lang="scss" scoped>
.cloudAuthBtn {
  width: 100%;
  background-color: #232235 !important;
  border: 1px solid #36344c;
}
</style>
